import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { Target } from '../TargetsContext/types'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { HelpMessage } from 'utils/constants'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'
import { alphabeticalCompare, Permission } from 'shared'
import { useTargetsContext } from '../TargetsContext'
import CIMSCheckbox from 'components/CIMSCheckbox'
import { useKeyedBooleans } from 'hooks/useKeyedBooleans'
import { useCheckPermission } from 'hooks/useCheckPermission'

export function useColumns(): CIMSColumn<Target>[] {
  const { refetch, edit } = useTargetsContext()
  const [loading, { add, remove }] = useKeyedBooleans()
  const canEdit = useCheckPermission(Permission.EditLIMSAsphaltMixDesignTarget)
  return [
    useNameColumn({ sort: { default: 'ascend' }, help: HelpMessage.Name }),
    useOptionalDescriptionColumn('Target'),
    {
      title: 'Required',
      width: 150,
      help: HelpMessage.Materials.Asphalt.Required,
      align: 'center',
      render: ({ required, id }) => (
        <CIMSCheckbox
          disabled={{ reason: 'missing permission', disabled: !canEdit }}
          checked={required}
          loading={loading(id)}
          onChange={async () => {
            add(id)
            await edit({ id, optional: required })
            remove(id)
            refetch()
          }}
        />
      ),
      sort: { with: 'key', key: 'required' },
      filter: { type: 'boolean', with: 'key', key: 'required' },
    },
    {
      title: 'Mix Designs',
      render: ({ percentages }) => percentages.length,
      sort: {
        with: 'callback',
        onCompare: (a, b) =>
          alphabeticalCompare(a.percentages, b.percentages, 'length'),
      },
      filter: {
        with: 'callback',
        type: 'default',
        items: (records) =>
          records
            .flatMap(({ percentages }) => percentages)
            .filter(({ mixDesign: { deleted } }) => !deleted)
            .map(({ mixDesign: { globalId, mixDesignNumber } }) => ({
              text: mixDesignNumber ?? 'Unknown',
              value: globalId,
            })),
        onFilter: (value, { percentages }) => {
          return percentages.some(
            ({ mixDesign }) => mixDesign.globalId === value
          )
        },
      },
      align: 'center',
      width: 175,
      help: HelpMessage.Materials.Asphalt.MixDesignsCount,
    },
  ]
}
